import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { CatalogItem } from '../../../@types/catalog-item';

const createLineItem = (cartId: string, catalogItem: CatalogItem) =>
  apiFetch(`/v1/carts/${cartId}/line-items`, {
    method: 'POST',
    body: JSON.stringify({
      data: {
        attributes: {
          external_id: catalogItem.id,
          original_price_cents: catalogItem.price_cents,
        },
        type: 'line_items',
      },
    }),
  });

export default createLineItem;
